import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import {eye} from 'react-icons-kit/icomoon/eye';
import {print} from 'react-icons-kit/fa/print';
import SvgIcon from 'react-icons-kit';
import moment from 'moment';
import Help from '../../generics/help';
import ModalFileType from '../../results_donation/components/modalFileType';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import Icon from "../petition_register/Components/MatrazIcon";
import ModalUnis from './modalUnis';

var Config = require('../../../config');

class SampleSearch extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.print = this.print.bind(this);
		this.modalSections = this.modalSections.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.getInfo = this.getInfo.bind(this);
		this.sampleResults = this.sampleResults.bind(this);

		this.state = {
			sample_id:"",
			sample:[],
			columns:[],
			lab_sections:[], 
			aux_id:"",
			lab_select_doc:{},
			type:"sample",
			patient_id:"",
			patient_list:[],
			loading_patient:false
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		

		fetch(Config.default.apiGateway.URL+'health_facilities/get_criterial?hf_id='+
			sessionStorage.getItem('health_facilities_id')+'&code=LAB_SELECT_DOC',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				lab_select_doc: response
			});
		})

    	fetch(Config.default.apiGateway.URL+'lab_sections/by_health_facility?id='+
    		sessionStorage.getItem('health_facilities_id'), {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var sections = [];
				response.map((res)=>{
					sections.push({
						section:res
					}) 				
				})

				this.setState({
					lab_sections: sections
				});

			}
		})
	}


	handleChange(e){
		this.setState({
			[e.target.name]:e.target.value
		});

		if(e.target.name === 'type'){
			this.setState({sample_id:"", patient_list:[], patient_id:""});
		}
	}

	onSearch(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'samples/from_patient?sample_number='+this.state.sample_id+'&patient_id='+this.state.patient_id+
			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', 'Registro no encontrado', 'error');
				});
			}		
			
		}).then(response =>{
			if(response !== undefined){
				this.setState({sample:response, sample_id:""});
			}
			/*if(response.donation_number !== undefined){
				this.setState({sample:response, sample_id:""});
			}else{
				swal('Error', 'Registro no encontrado', 'error');
			}*/
		})
		
	}

	viewInfo(sample, petition){
		this.props.history.push('/sample_results/'+sample+'/'+petition+'/0');
	}

	async print(e, file_type = 'lab_results_patients', ids = []){

		this.props.waiting.handleShow('Imprimiendo...');
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.state.sample.id; //this.props.match.params.sample_id;
		obj.file_type = file_type
		if(file_type === 'lab_results_patients'){
			if(this.state.lab_select_doc.value !== 'NO'){
				obj.option = 'filter';	
			}
			
		}else{
			obj.ids = ids;
		}
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({aux_id:""});
		}else{
			this.props.waiting.handleClose();
		}
	
		
  	}

  	modalSections(){
  		this.file_type_modal.handleShow();
	}
	  
	handleSearch = (query) => {
	    this.setState({loading_patient: true});
	    
		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
			}),
			cache:'no-cache'
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					
					/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
											+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}


					if(response[i].document_type_value !== null){
						response[i].names +=' '+response[i].document_type_value;
					}

					if(response[i].document_number !== null){
						response[i].names +=' '+response[i].document_number;
					}

					if(response[i].number !== null){
						response[i].names += ' '+response[i].number
					}
					
					response[i].id = response[i].patient_id;
				};
				

				//error
				this.setState({
					loading_patient: false,
			     	patient_list: response,
			    });
				
			}
		})
	}

	getInfo(e){
		if(e.length > 0){
			this.setState({patient_id: e[0].patient_id});

			setTimeout(()=>{
				this.onSearch();
			}, 500);
		}
		
	}

	sampleResults(e, sample){
		e.preventDefault();
		this.props.history.push({
			pathname:'/sample_results/'+sample.id+'/'+sample.petition_id+'/0',
			state:{
				from:this.props.location.pathname
			}
		})
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
					    {sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Busqueda de Muestra
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_sample_search"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Buscar por:</span>
						<select name="type" id="type" value={this.state.type}
							onChange={this.handleChange} className="form-control">
							<option value="">Seleccione...</option>
							<option value="sample">No muestra / No. petición</option>
							<option value="patient">Paciente</option>
						</select>
					</div>
					{this.state.type === 'sample' &&
						<div className="col-xs-10">
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">No. Muestra / No. petición</span>
								<input type="text" name="sample_id" id="sample_id" value={this.state.sample_id || ""} 
									onChange={this.handleChange} className="form-control" />
							</div>
							<div className="col-xs-12 col-sm-1" style={{marginTop:"11px"}}>
								<button type="button" className="btn btn-info" style={{fontSize:"1em"}}
									onClick={this.onSearch}>
									{t('content.generics.buttons.search')}
								</button>
							</div>
						</div>
					}
					{this.state.type === 'patient' &&
						<div className="col-xs-10">
							<div className="col-xs-12 col-sm-8">
								<span className="span-min">Paciente</span>
								<AsyncTypeahead
									labelKey={(option) => `${option.names}`}
									minLength={0}
									options={this.state.patient_list}
									onSearch={this.handleSearch}
									onChange={this.getInfo}
									name="patient_id"
									id="patient_id"
									isLoading={this.state.loading_patient}
									reuired={true}
									placeholder="Buscar por apellidos más nombre o número de documento"
									ref={ref => this._typeahead = ref}
									useCache={false}
									delay={800}
									paginationText="Mostrar mas resultados..."
								/>
							</div>
						</div>
					}
				</div>
				

				
				
				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>No. Petición</th>
								<th>Fecha Petición</th>
								<th>No. Muestra</th>
								<th>Fecha Muestra</th>
								<th>Paciente</th>
								<th>Petición</th>
								<th>Laboratorio</th>
								<th>Hemovigilancia</th>
							</tr>
						</thead>
						<tbody>
							{this.state.sample.map((s, i)=>
								<tr>
									<td>{s.petition_number}</td>
									<td>
										{moment(s.petition_date).format('DD/MM/YYYY HH:mm')}
									</td>
									<td>{s.sample_number}</td>
									<td>
										{moment(s.date).format('DD/MM/YYYY HH:mm')}
									</td>
									<td>{s.patient_name}</td>
									<td>										
										<SvgIcon icon={pencil2} className="icon-align" size={25} style={{cursor:'pointer'}}
											onClick={(e)=>{e.preventDefault(); return this.props.history.push('/petition_register/edit/'+s.petition_id);}}
										/>
									</td>
									<td>
										<a href="" 
											onClick={(e)=>this.sampleResults(e,s)}>
											<Icon width={25} title="Laboratorio"
												fill={'rgb(var(--primary))'}
												/>											
										</a>
									</td>
									<td>
										<SvgIcon icon={eye}  size={25} 
											style={s.units_delivered.length > 0 ? 
													{cursor:'pointer', color:'rgb(var(--primary))'} 
												:{cursor:'no-drop', color:'#a39f9f'}}
											onClick={(e)=>{
												e.preventDefault(); 

												if(s.units_delivered.length > 0){
													this.modal_units.handleShow(s.units_delivered);
												}

												return;
											}}
										/>
									</td>
								</tr>
							)}
							{/*this.state.sample.id !== undefined ?
								<tr>
									<td>{this.state.sample.sample_number}</td>
									<td>
										{moment(this.state.sample.date).format('DD/MM/YYYY')+' '}
										{moment(this.state.sample.date).format('HH:mm')}
									</td>
									<td>{this.state.sample.patient_name}</td>
									<td>
										<button className="btn btn-info" title="Ver" type="button" 
											disabled={this.state.sample.id === 0}
											onClick={this.viewInfo.bind(this, this.state.sample.id, this.state.sample.petition_id)}>
					                        <SvgIcon icon={eye}/>
					                     </button>

					                     <button className="btn btn-info" title="Imprimir" type="button" 
					                     	style={{marginLeft:'8px'}}
											disabled={this.state.sample.id === 0}
											onClick={(e)=>this.state.lab_select_doc.value === 'NO' ? 
												this.print(e)
											:this.modalSections()}>
					                        <SvgIcon icon={print}/>
					                     </button>
									</td>
								</tr>
							:null*/}
						</tbody>
					</Table>
				</div>

				<ModalUnis {...this.props} onRef={ref => (this.modal_units = ref)} />
				<ModalFileType {...this.props} onRef={ref => (this.file_type_modal = ref)} 
					print={this.print} sections={this.state.lab_sections} />
			</div>
		)
	
	}
}

export default translate('translations') (SampleSearch);